module.exports = __webpack_public_path__ + "img/female12.538f91e6.jpeg";